import { useState } from 'react';
import type { SimulatedPayload } from './AppContent.types';

export const useGraphQLSimulation = () => {
  const [simulatingQuery, setSimulatingQuery] = useState<string | null>(null);
  const [simulatedPayload, setSimulatedPayload] = useState<SimulatedPayload | null>(null);

  const simulateGraphQL = (queryName: string, hash: string, _queryBody: string) => {
    setSimulatingQuery(queryName);
    setSimulatedPayload({
      url: 'https://wealthiq-api.example.com/graphql',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Persisted-Query-Only': 'true',
      },
      body: {
        operationName: queryName,
        extensions: {
          persistedQuery: {
            version: 1,
            sha256Hash: hash,
          },
        },
      },
      explanation: `The server/router receives the SHA-256 hash instead of the query body. It cross-references the hash with the safelisted PQL manifest and resolves the request, preventing un-safelisted operations.`,
    });
  };

  return { simulatingQuery, simulatedPayload, simulateGraphQL };
};
